import Hotjar from '@hotjar/browser';

const HOTJAR_SNIPPET_VERSION = 6
export function initializeHotjar(userId) {
  Hotjar.init(parseInt(process.env.GATSBY_HOTJAR_ID), HOTJAR_SNIPPET_VERSION);
  Hotjar.identify(userId, {})
}

